import { ProgramAPI, SoilTestAPI, TexturesAPI } from '@/api'

const DefaultNutsForm = function () {
  this.cec = 0;
  this.textureId = 0;
}

export default {
  namespaced: true,
  state: {

    nutrients: {},
    nutrients_form: new DefaultNutsForm(),
    npks: [],

  },
  mutations: {
    setNutrients(state, data) {
      state.nutrients = data;
    },

    setTextures(state, data) {
      state.textures = data;
    },

    setNutrientsForm(state, data) {
      // state.nutrients_form = data;

      if (data.cec) {
        state.nutrients_form.cec = data.cec;
      }
      if (data.textureId) {
        state.nutrients_form.textureId = data.textureId;
      }
    },

    setNPKs(state, data) {
      state.npks = data;
    },
  },
  actions: {

    async onUpdate({ dispatch, rootGetters }) {

      const prog = rootGetters['program/data'];

      await dispatch('program/steps/setCurrentStep', 'base-dressing', { root: true });
      // await dispatch('program/steps/setCurrentStepNextFromSelectedStep', 'base-dressing', { root: true });

      dispatch('program/fertigation/destroyState', '', { root: true });
      dispatch('program/fertilizers/destroyState', '', { root: true });
      dispatch('program/blend/destroyState', '', { root: true });
    },

    destroyState({ state, commit }) {
      state.nutrients = {};
      state.nutrients_form = new DefaultNutsForm();
      state.npks = [];
    },
    
    async initNutrients({ rootGetters, state, commit, getters }) {
      const program = rootGetters['program/data'];
      const has_soil_test = (!!program.soilTest && !!program.soilTestId);      
      
      if(has_soil_test) {
        const soil_test = await SoilTestAPI.get(program.soilTestId).then(res => res.data);
        const npk = getters.getNPKByTexture(soil_test.textureId);
        const nutrients = getters.getNutrientsByNPK(npk);

        state.nutrients_form.textureId = soil_test.textureId;
        
        commit('setNutrients', nutrients);
      } else {
        const nutrients = getters.getNutrientsByNPK(getters.npks[0]);

        commit('setNutrients', nutrients);
      }
    },

    updateNutrients({ rootGetters, state, commit, getters }) {
      const npk = getters.getNPKByTexture(state.nutrients_form.textureId);
      const nutrients = getters.getNutrientsByNPK(npk);
      commit('setNutrients', nutrients);
    },

    getNutrients({ state, commit, rootGetters }) {
      return ProgramAPI.getBaseDressingNutrientsTable(rootGetters['program/data'].id).then(res => {
        // console.log(res);
        if (res.data.data.data) {
          commit('setNutrients', res.data.data.data);
        }

        if (res.data.cec && typeof(res.data.cec) === 'number') {
          commit('setNutrientsForm', {
            cec: res.data.cec
          });
        } else {
          commit('setNutrientsForm', {
            cec: res.data.data.cec,
            textureId: res.data.data.textureId,
          });
        }
      });
    },

    async saveNutrients({ state, rootGetters }) {
      await ProgramAPI.saveBaseDressingNutrients({
        // TODO поменять название
        NPK_nutrients: state.nutrients,
        programId: rootGetters['program/data'].id,
        ...state.nutrients_form,
      });
    },

    selectNPKs({ commit }) {
      return ProgramAPI.getBaseDressingNutrients().then(res => {
        // console.log(res);
        commit('setNPKs', res.data.data);
      });
    },

  },
  getters: {
    nutrients(state) {
      return state.nutrients
    },

    nutrientsForm(state) {
      return state.nutrients_form
    },

    isNutrientsLoaded(state) {
      return state.nutrients_loaded
    },

    npks(state) {
      return state.npks;
    },

    // Это оставить на будущее
    // getNutrientsByTexture: (state, getters, rootState, rootGetters) => texture => {
    //   return rootGetters['nutrients/topLevelNutrients'].map(n => {
    //     if(n.key === 'N') {
    //       n.value = texture.N;
    //     }
    //     else if(n.key === 'P') {
    //       n.value = texture.P;
    //     }
    //     else if(n.key === 'K') {
    //       n.value = texture.K;
    //     }
    //     else {
    //       n.value = 0;
    //     }
    //     return n;
    //   });
    // }


    getNPKByTexture: (state, getters) => texture_id => {
      return state.npks.find(n => n.soilTypeId === texture_id);
    },

    getClearByNpk: (state, getters, rootState, rootGetters) => {
      const init_val = { 'BDPercents': {} };
      // console.log(rootGetters['nutrients/topLevelNutrients']);

      return rootGetters['nutrients/topLevelNutrients'].reduce((acc, n) => {
        let other = ['N', 'P', 'K', 'Ca', 'Mg', 'S', 'B', 'Fe', 'Cl'];
        // let other = ['N', 'P', 'K'];
        if (other.includes(n.key)) {
          acc['BDPercents'][n.key + '_Val'] = 0;
        }

        return acc;
      }, init_val);
    },


    getNutrientsByNPK: (state, getters, rootState, rootGetters) => npk => {

      // const init_val = { 'BDPercents': {} };
      let init_val = state.nutrients;
      // console.log(rootGetters['nutrients/topLevelNutrients']);
      if (init_val['BDPercents']) {
        for (let key in npk) {
          // console.log();
          state.nutrients.BDPercents[key + '_Val'] = npk[key];
        }

        return state.nutrients;
      } else {
        init_val = getters.getClearByNpk;

        for (let key in npk) {
          init_val.BDPercents[key + '_Val'] = npk[key];
        }

        return init_val;
      }

      // return rootGetters['nutrients/topLevelNutrients'].reduce((acc, n) => {
      //   if(n.key === 'N') {
      //     acc['BDPercents']['N_Val'] = npk.N;
      //   }
      //   else if(n.key === 'P') {
      //     acc['BDPercents']['P_Val'] = npk.P;
      //   }
      //   else if(n.key === 'K') {
      //     acc['BDPercents']['K_Val'] = npk.K;
      //   }

      //   let other = ['Ca', 'Mg', 'S', 'B', 'Fe', 'Mn', 'Zn', 'Cu', 'Mo'];
      //   if (other.includes(n.key)) {
      //     acc['BDPercents'][n.key + '_Val'] = 0;
      //   }

      //   return acc;
      // }, init_val);
    },
    

    getNPKByTexture: (state, getters, rootState, rootGetters) => texture_id => {
      return state.npks.find(n => n.soilTypeId == texture_id);
    }
  }
};
